module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/info_image@2x.fdbbc1c.png";